import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseConocimientoDto } from '../../../dto/justino/base-conocimiento.dto';
import { BaseConocimientoService } from '../../../services/base-conocimiento.service';
import { ModalNomDesComponent } from '../modal-nom-des/modal-nom-des.component';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { SpinnerService } from '../../../services/util/spinner.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormField } from '../../../dto/util/form-field';
import { DominioDto } from '../../../dto/justino/dominio.dto';
import { ModalSelecEleComponent } from '../modal-selec-ele/modal-selec-ele.component';
import { DominioService } from '../../../services/dominio.service';

@Component({
  selector: 'app-base-conocimiento',
  templateUrl: './base-conocimiento.component.html',
  styleUrl: './base-conocimiento.component.scss',
})
export class BaseConocimientoComponent {
  // Track the current page
  currentPage: number = 1;
  // Track the search term
  searchTerm: string = '';
  // Define la lista de basesConocimiento
  basesConocimiento: BaseConocimientoDto[] = [];
  dominios: DominioDto[] = [];
  dominiosSistema: DominioDto[] = [];
  // Define el mensaje sin datos
  mensaje: string = 'No hay datos disponibles.';
  modalNDFlag: boolean = false;
  modalEleFlag: boolean = false;
  listFlag: boolean = true;
  readFlag: boolean = false;
  baseConocimiento!: BaseConocimientoDto;

  baseConocimientoForm!: FormGroup;
  isReadOnly: boolean = true; // Initially, form is in read mode
  nomDesForm: FormField[] = [
    {
      name: 'nombre',
      label: 'Nombre',
      type: 'text',
      required: true,
      width: '12',
      visible: true,
      errorMessages: {
        required: 'El nombre es requerido',
        pattern:
          'Solo se permiten letras, números y guiones (-). Ejemplo: nombre-1, dos-nombres',
      },
    },
    {
      name: 'descripcion',
      label: 'Descripción',
      type: 'textarea',
      required: true,
      width: '12',
      visible: true,
      errorMessages: {
        required: 'La descripción es requerida',
      },
    },
    {
      name: 'estado',
      label: 'Estado',
      type: 'select',
      required: true,
      width: '6',
      visible: true,
      errorMessages: { required: 'El estado es obligatorio' },
    },
  ];
  estados = ['Activo', 'Inactivo'];

  @ViewChild(ModalNomDesComponent)
  modalND!: ModalNomDesComponent;

  @ViewChild(ModalSelecEleComponent)
  modalEle!: ModalSelecEleComponent;

  constructor(
    private fb: FormBuilder,
    private spinnerService: SpinnerService,
    private dominioService: DominioService,
    private baseConocimientoService: BaseConocimientoService,
    private alertService: AlertaModalService
  ) {}

  ngOnInit(): void {
    this.loadDominios();
    this.loadBasesConocimiento();
    this.createForm();
  }

  loadBasesConocimiento(): void {
    this.baseConocimientoService.getBasesConocimiento().subscribe({
      next: data => {
        this.basesConocimiento = data;
      },
      error: err => {
        this.alertService.error(
          `Error al cargar las bases de conocimiento: ${err.statusText}`
        );
      },
    });
  }

  editarBaseConocimiento(baseConocimiento: BaseConocimientoDto) {
    // Limpia
    this.baseConocimientoForm.reset();
    this.dominios = [];
    // Cargo los dominios de la base de conocimiento
    this.baseConocimiento = baseConocimiento;
    this.listFlag = false;
    this.readFlag = true;
    this.isReadOnly = false;
    
    // Cargar los dominios relacionados de forma segura
    this.loadDominiosRelacionados();
    
    this.fillFormWithData();
    if (this.isReadOnly) {
      this.baseConocimientoForm.disable();
    } else {
      this.baseConocimientoForm.enable();
    }
  }

  eliminarBaseConocimiento(id: string) {
    this.alertService.confirmacion(
      '¿Desea eliminar la base de conocimiento?',
      'Eliminar',
      () => {
        this.baseConocimientoService.deleteBaseConocimiento(id).subscribe({
          next: () => {
            this.spinnerService.hideSpinner();
            this.alertService.exito(
              'Mensaje informativo',
              'Base de conocimiento eliminado correctamente'
            );
            this.loadBasesConocimiento();
          },
          error: err => {
            this.spinnerService.hideSpinner();
            this.alertService.error(
              `Error al eliminar el base de conocimiento: ${err.statusText}`
            );
          },
        });
      },
      () => {}
    );
  }

  registrarBaseConocimiento(dto: any) {
    const nuevoNombre = dto.nombre;
    const nuevoDescripcion = dto.descripcion;
    this.modalND.abrirCerrarModal();
    if (nuevoNombre && nuevoNombre.trim() !== '') {
      const nuevoBaseConocimiento: BaseConocimientoDto = {
        Id: '0',
        Nombre: nuevoNombre,
        Descripcion: nuevoDescripcion,
        Estado: 'Activo',
        FechaCreacion: new Date().toISOString(),
        FechaModificacion: new Date().toISOString(),
        UsuarioCreacion: 'admin',
        UsuarioModificacion: 'admin',
        Dominios: [],
      };
      this.baseConocimientoService
        .createBaseConocimiento(nuevoBaseConocimiento)
        .subscribe({
          next: () => {
            this.spinnerService.hideSpinner();
            this.alertService.exito(
              'Mensaje informativo',
              'BaseConocimiento creado correctamente'
            );
            this.loadBasesConocimiento();
          },
          error: err => {
            this.spinnerService.hideSpinner();
            this.alertService.error(
              `Error al crear el baseConocimiento ${err.statusText}`
            );
          },
        });
    }
  }

  async crearBaseConocimiento() {
    this.abrirModalND();
  }

  abrirModalND() {
    this.modalNDFlag = true;
    setTimeout(() => {
      this.modalND.abrirCerrarModal();
    }, 500);
  }

  onRowClick(baseConocimiento: BaseConocimientoDto) {
    // Limpia
    this.baseConocimientoForm.reset();
    this.dominios = [];
    // Cargo los dominios de la base de conocimiento
    this.baseConocimiento = baseConocimiento;
    this.listFlag = false;
    this.readFlag = true;
    this.isReadOnly = this.readFlag;
    
    // Cargar los dominios relacionados de forma segura
    this.loadDominiosRelacionados();
    
    this.fillFormWithData();
    if (this.isReadOnly) {
      this.baseConocimientoForm.disable();
    } else {
      this.baseConocimientoForm.enable();
    }
  }

  // Método helper para cargar dominios relacionados de forma segura
  loadDominiosRelacionados(): void {
    if (!this.baseConocimiento || !this.baseConocimiento.Dominios) {
      this.dominios = [];
      return;
    }

    // Filtrar solo los dominios que existen en el sistema y no son null/undefined
    this.dominios = this.baseConocimiento.Dominios
      .map(id => this.dominiosSistema.find(d => d.Id === id))
      .filter(dominio => dominio !== undefined) as DominioDto[];

    // Limpiar IDs de dominios que ya no existen del array principal
    const dominiosValidosIds = this.dominios.map(d => d.Id);
    this.baseConocimiento.Dominios = this.baseConocimiento.Dominios.filter(id => 
      dominiosValidosIds.includes(id)
    );
  }

  volverElemento() {
    this.listFlag = true;
    this.readFlag = false;
    this.isReadOnly = this.readFlag;
    this.baseConocimientoForm.reset();
  }

  createForm(): void {
    const formControls: any = {};
    this.nomDesForm.forEach(field => {
      const validators = [];
      if (field.required) {
        validators.push(Validators.required);
      }
      if (field.name === 'nombre') {
        validators.push(Validators.pattern(/^[a-zA-Z0-9-]+$/));
      }
      formControls[field.name] = [null, validators];
    });
    this.baseConocimientoForm = this.fb.group(formControls);
    if (this.isReadOnly) {
      this.baseConocimientoForm.disable();
    }
  }

  fillFormWithData(): void {
    if (this.baseConocimiento) {
      this.baseConocimientoForm.patchValue({
        nombre: this.baseConocimiento.Nombre,
        descripcion: this.baseConocimiento.Descripcion,
        estado: this.baseConocimiento.Estado,
      });
    }
  }

  getErrorMessage(field: string): string | null {
    const control = this.baseConocimientoForm.get(field);
    if (control?.invalid && control.touched) {
      const errorType = Object.keys(control.errors!)[0];
      return (
        this.nomDesForm.find(f => f.name === field)?.errorMessages?.[
          errorType
        ] || 'Campo inválido'
      );
    }
    return null;
  }

  toggleEdit(): void {
    this.isReadOnly = !this.isReadOnly;
    if (this.isReadOnly) {
      this.baseConocimientoForm.disable();
    } else {
      this.baseConocimientoForm.enable();
    }
  }

  isNameUnique(name: string): boolean {
    return !this.basesConocimiento.some(
      el => el.Nombre.toLowerCase() === name.toLowerCase()
    );
  }

  submitForm(): void {
    if (this.baseConocimientoForm.valid) {
      const dto = this.baseConocimientoForm.value;
      if (this.baseConocimiento.Nombre != dto.nombre) {
        if (!this.isNameUnique(dto.nombre)) {
          this.alertService.error(
            'Error al actualizar el base de conocimiento',
            'El nombre ya existe'
          );
          return;
        }
      }
      this.baseConocimiento.Nombre = dto.nombre;
      this.baseConocimiento.Descripcion = dto.descripcion;
      this.baseConocimiento.Estado = dto.estado;
      this.baseConocimientoService
        .updateBaseConocimiento(this.baseConocimiento.Id, this.baseConocimiento)
        .subscribe({
          next: () => {
            this.spinnerService.hideSpinner();
            this.alertService.exito(
              'Mensaje informativo',
              'Base de conocimiento actualizado correctamente'
            );
            this.loadBasesConocimiento();
          },
          error: err => {
            this.spinnerService.hideSpinner();
            this.alertService.error(
              `Error al actaulizar el base de conocimiento: ${err.statusText}`
            );
          },
        });
      this.isReadOnly = true;
      this.baseConocimientoForm.disable();
    } else {
      this.baseConocimientoForm.markAllAsTouched();
    }
  }

  desvincularDominio(id_dominio: string) {
    this.baseConocimiento.Dominios = this.baseConocimiento.Dominios.filter(
      d => d !== id_dominio
    );
    this.baseConocimientoService
      .updateBaseConocimiento(this.baseConocimiento.Id, this.baseConocimiento)
      .subscribe({
        next: () => {
          this.spinnerService.hideSpinner();
          this.alertService.exito(
            'Mensaje informativo',
            'Base de conocimiento actualizado correctamente'
          );
          // Usar el método helper para cargar dominios de forma segura
          this.loadDominiosRelacionados();
        },
        error: err => {
          this.spinnerService.hideSpinner();
          this.alertService.error(
            `Error al actaulizar el base de conocimiento: ${err.statusText}`
          );
        },
      });
  }

  loadDominios(): void {
    this.dominioService.getDominios().subscribe({
      next: data => {
        this.dominiosSistema = data;
      },
      error: err => {
        this.alertService.error(
          `Error al cargar los dominios: ${err.statusText}`
        );
      },
    });
  }

  async relacionarDominio() {
    this.loadDominios();
    this.abrirModalEle();
  }

  abrirModalEle() {
    this.modalEleFlag = true;
    setTimeout(() => {
      const dominiosSis = this.dominiosSistema.filter(
        d => !this.baseConocimiento.Dominios.includes(d.Id)
      );
      this.modalEle.abrirModalRelacionar(dominiosSis);
    }, 500);
  }

  registrarDominio(id_dominio: string) {
    console.log(this.baseConocimiento.Dominios);
    if (this.baseConocimiento.Dominios.includes(id_dominio)) {
      this.alertService.error(
        'Error al relacionar dominio',
        'El dominio ya está relacionado con esta base de conocimiento'
      );
      return;
    }

    this.baseConocimiento.Dominios.push(id_dominio);
    this.baseConocimientoService
      .updateBaseConocimiento(this.baseConocimiento.Id, this.baseConocimiento)
      .subscribe({
        next: () => {
          this.spinnerService.hideSpinner();
          this.alertService.exito(
            'Mensaje informativo',
            'Base de conocimiento actualizado correctamente'
          );
          // Usar el método helper para cargar dominios de forma segura
          this.loadDominiosRelacionados();
        },
        error: err => {
          this.spinnerService.hideSpinner();
          this.alertService.error(
            `Error al actaulizar el base de conocimiento: ${err.statusText}`
          );
        },
      });
  }
}
